import WorkflowActionTypes from './types';

const initialState = {
  collectionEnums: {},
  mapData: [],
  collectionItem: {},
  isfetching: false,
  scheduledVehiclesData: {},
  scheduledItenaryData: {},
  pathData: {},
  filters: {},
  consignees: [],
  scheduledCount: {},
  collectionSaved: false,
  consignmentUpdated: false,
  snackbarState: { show: false, type: 'success', message: '' },
  currentLocation: {},
  invoiceDeleted: false,
  docketData: [],
  docketDeleted: false,
  docketSaved: false,
  actionTimeValidated: false,
  tripDeleted: false,
};

const workflowReducer = (state: object = initialState, action: { type: string; payload: any }) => {
  switch (action.type) {
    case WorkflowActionTypes.FETCH_COLLECTION_ENUMS_SUCCESS:
      return {
        ...state,
        collectionEnums: action.payload,
      };

    case WorkflowActionTypes.FETCH_SCHEDULED_MAP_SUCCESS:
      return {
        ...state,
        mapData: action.payload,
      };

    case WorkflowActionTypes.FETCH_COLLECTION_DATA_START:
      return {
        ...state,
        isFetching: true,
      };

    case WorkflowActionTypes.UPDATE_CONSIGNMENT:
      return {
        ...state,
        isFetching: true,
        consignmentUpdated: false,
      };

    case WorkflowActionTypes.DELETE_INVOICE_START:
      return {
        ...state,
        invoiceDeleted: false,
      };

    case WorkflowActionTypes.DELETE_INVOICE_SUCCESS:
      return {
        ...state,
        invoiceDeleted: true,
        snackbarState: { show: true, type: 'success', message: 'Invoice deleted successfully' },
      };

    case WorkflowActionTypes.UPDATE_CONSIGNMENT_SUCCESS:
      return {
        ...state,
        consignmentUpdated: true,
        snackbarState: { show: true, type: 'success', message: 'Consignment updated successfully' },
      };

    case WorkflowActionTypes.FETCH_DOCKET_DATA_START:
      return {
        ...state,
        isFetching: true,
      };

    case WorkflowActionTypes.FETCH_DOCKET_DATA_SUCCESS:
      return {
        ...state,
        docketData: action.payload,
      };

    case WorkflowActionTypes.GET_CURRENT_LOCATION_SUCCESS:
      return {
        ...state,
        currentLocation: action.payload,
      };

    case WorkflowActionTypes.FETCH_FILTERS_START:
      return {
        ...state,
        isFetching: true,
      };

    case WorkflowActionTypes.DELETE_DOCKET_START:
      return {
        ...state,
        isFetching: true,
        docketDeleted: false,
      };

    case WorkflowActionTypes.DELETE_DOCKET_SUCCESS:
      return {
        ...state,
        docketDeleted: true,
        snackbarState: { show: true, type: 'success', message: 'Docket deleted successfully' },
      };

    case WorkflowActionTypes.DELETE_TRIP_START:
      return {
        ...state,
        isFetching: true,
        tripDeleted: false,
      };

    case WorkflowActionTypes.DELETE_TRIP_SUCCESS:
      return {
        ...state,
        isFetching: false,
        tripDeleted: true,
        snackbarState: { show: true, type: 'success', message: 'trip deleted successfully' },
      };

    case WorkflowActionTypes.SAVE_COLLECTION_START:
      return {
        ...state,
        collectionSaved: false,
      };

    case WorkflowActionTypes.SAVE_DOCKET_START:
      return {
        ...state,
        docketSaved: false,
      };

    case WorkflowActionTypes.SAVE_COLLECTION_SUCCESS:
      return {
        ...state,
        collectionSaved: true,
        snackbarState: { show: true, type: 'success', message: 'Collection updated successfully' },
      };

    case WorkflowActionTypes.RESET_SNACKBAR:
      return {
        ...state,
        snackbarState: { show: false, type: 'success', message: '' },
      };

    case WorkflowActionTypes.SAVE_DOCKET_SUCCESS:
      return {
        ...state,
        docketSaved: true,
        snackbarState: { show: true, type: 'success', message: 'Docket updated successfully' },
      };

    case WorkflowActionTypes.FETCH_FILTERS_SUCCESS:
      return {
        ...state,
        isFetching: false,
        filters: action.payload,
      };

    case WorkflowActionTypes.FETCH_COLLECTION_DATA_SUCCESS:
      return {
        ...state,
        collectionItem: action.payload,
        isFetching: false,
      };

    case WorkflowActionTypes.FIND_CONSIGNEE:
      return {
        ...state,
        isFetching: true,
      };

    case WorkflowActionTypes.FIND_CONSIGNEE_SUCCESS:
      return {
        ...state,
        consignees: action.payload,
        isFetching: false,
      };

    case WorkflowActionTypes.FETCH_SCHEDULED_VEHICLES_START:
      return {
        ...state,
        isFetching: true,
      };

    case WorkflowActionTypes.FETCH_SCHEDULED_ITENARY_START:
      return {
        ...state,
        isFetching: true,
      };

    case WorkflowActionTypes.FETCH_PATH_DETAIL_START:
      return {
        ...state,
        isFetching: true,
      };

    case WorkflowActionTypes.VALIDATE_ACTION_TIME:
      return {
        ...state,
        isFetching: true,
      };

    case WorkflowActionTypes.FETCH_PATH_DETAIL_SUCCESS:
      return {
        ...state,
        isFetching: false,
        pathData: action.payload,
      };

    case WorkflowActionTypes.RESET_PATH_ITENARY_DATA:
      return {
        ...state,
        pathData: {},
        scheduledItenaryData: {},
        currentLocation: {},
      };

    case WorkflowActionTypes.VALIDATE_ACTION_TIME_SUCCESS:
      return {
        ...state,
        isFetching: false,
        actionTimeValidated: true,
      };

    case WorkflowActionTypes.FETCH_SCHEDULED_ITENARY_SUCCESS:
      return {
        ...state,
        isFetching: false,
        scheduledItenaryData: action.payload,
      };

    case WorkflowActionTypes.FETCH_SCHEDULED_VEHICLES_SUCCESS:
      return {
        ...state,
        isFetching: false,
        scheduledVehiclesData: action.payload,
      };
    case WorkflowActionTypes.FETCH_SCHEDULED_COUNT_START:
      return {
        ...state,
        isFetching: true,
      };
    case WorkflowActionTypes.FETCH_SCHEDULED_COUNT_SUCCESS:
      return {
        ...state,
        isFetching: false,
        scheduledCount: action.payload,
      };

    default:
      return state;
  }
};

export default workflowReducer;
